module.exports = __webpack_public_path__ + "media/commencement.51c62642.mp4";